import { Switch, Route, Router as WouterRouter } from "wouter";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import type { HelmetServerState } from "react-helmet-async";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";

import Home from "@/pages/home";
import About from "@/pages/about";
import FAQ from "@/pages/faq";
import Apply from "@/pages/apply";
import Industry from "@/pages/industry";
import Contact from "@/pages/contact";
import ServiceAreas from "@/pages/service-areas";
import Resources from "@/pages/resources";
import Resource from "@/pages/resource";
import Financing from "@/pages/financing";
import FinancingLocation from "@/pages/financing-location";
import NotFound from "@/pages/not-found";
import { ComingSoon } from "@/components/ComingSoon";
import siteMode from "./site-mode.json";

const queryClient = new QueryClient();

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path="/about" component={About} />
      <Route path="/faq" component={FAQ} />
      <Route path="/apply" component={Apply} />
      <Route path="/industries/:industry" component={Industry} />
      <Route path="/contact" component={Contact} />
      <Route path="/service-areas" component={ServiceAreas} />
      <Route path="/resources" component={Resources} />
      <Route path="/resources/:slug" component={Resource} />
      <Route path="/:slug" component={Financing} />
      <Route path="/:slug/:state" component={FinancingLocation} />
      <Route component={NotFound} />
    </Switch>
  );
}

export interface AppProps {
  /** SSR-only: the path to render. Omitted on the client, where wouter reads the location. */
  ssrPath?: string;
  /** SSR-only: collects Helmet state during server render. */
  helmetContext?: { helmet?: HelmetServerState };
}

function App({ ssrPath, helmetContext }: AppProps = {}) {
  return (
    <HelmetProvider context={helmetContext}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <WouterRouter
            base={import.meta.env.BASE_URL.replace(/\/$/, "")}
            ssrPath={ssrPath}
          >
            {siteMode.maintenance ? <ComingSoon /> : <Router />}
          </WouterRouter>
          <Toaster />
        </TooltipProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
}

export default App;
